var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-right lg:text-left"},[_c('span',{class:['status-marker', _vm.color]},[(_vm.statusMessage)?_c('span',[_vm._v(_vm._s(_vm.statusMessage))]):_c('span',{staticClass:"text-[#BABBC2]"},[_vm._v(_vm._s(_vm.locales && _vm.locales.property && _vm.locales.property.inactive))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }